import Navbar from "./Navbar";
import Footer from "./Footer";
import StickyMobileCTA from "./StickyMobileCTA";
import SupportBanner from "./SupportBanner";
import Announcer from "@/components/a11y/Announcer";

export default function PublicLayout({ children, hideFooter = false }) {
    return (
        <div className="min-h-screen flex flex-col bg-bl-bg">
            {/* Skip-to-content link — WCAG 2.4.1 (Bypass Blocks). Hidden
                off-screen until focused via keyboard tab. */}
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:px-4 focus:py-2 focus:bg-bl-primary focus:text-bl-surface focus:rounded-md focus:shadow-lg focus:font-medium focus:text-sm"
                data-testid="skip-to-main"
            >
                Skip to main content
            </a>
            <SupportBanner />
            <Navbar />
            <main
                id="main-content"
                tabIndex={-1}
                className="flex-1 focus:outline-none"
            >
                {children}
            </main>
            {!hideFooter && <Footer />}
            <StickyMobileCTA />
            {/* Global aria-live region — components call announce() to
                push concise updates to screen readers. */}
            <Announcer />
        </div>
    );
}
